// components/ActionsWidget.js

import React from 'react';
import { FaProjectDiagram, FaBug, FaPowerOff } from 'react-icons/fa';
import './ActionsWidget.css'; 

function ActionsWidget({ onFeatureRequest, onBugReport, onSignOut }) {
    return (
        <div className="widget action-widget">
            <div className="widget-header">Actions</div>
            <div className="widget-content action-buttons">
                <button className="action-button" onClick={onFeatureRequest}>
                    <FaProjectDiagram className="action-icon" /> Feature Request
                </button>
                <button className="action-button" onClick={onBugReport}>
                    <FaBug className="action-icon" /> Bug Report
                </button>
                <button className="action-button" onClick={onSignOut}>
                    <FaPowerOff className="action-icon" /> Sign Out
                </button>
            </div>
        </div>
    );
}

export default ActionsWidget;
